import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import "./index.css";

// Initialize Sentry
Sentry.init({
  dsn: "https://9f0530e838c309e2e0c53b9c99b49225@o4504698557693952.ingest.us.sentry.io/4509069866434560",
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/(www\.)?gugudata\.ai/],
  // Session Replay disabled to avoid consuming reserved replay volume.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
